module.exports = __webpack_public_path__ + "img/certificate.f056f627.svg";